import React from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const MonitoringPlans = () => {
  const { dict } = useLanguage();
  const m = dict.monitoring;

  return (
    <section id="monitoring" className="py-16 bg-gradient-to-b from-purple-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <span className="inline-block mb-4 px-4 py-1.5 rounded-full bg-purple-100 text-purple-800 text-xs font-bold tracking-wider">
            {m.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-black">{m.title}</h2>
          <p className="text-gray-600 text-lg">{m.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto items-stretch">
          {m.plans.map((plan) => {
            const featured = Boolean(plan.featured);
            return (
              <div
                key={plan.name}
                className={`relative flex flex-col rounded-2xl bg-white p-6 shadow-md ${
                  featured
                    ? 'border-2 border-purple-600 shadow-purple-100 md:-translate-y-2'
                    : 'border border-gray-200'
                }`}
              >
                {featured && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-purple-600 text-white text-xs font-bold tracking-wide px-3 py-1 rounded-full">
                    {m.recommended}
                  </span>
                )}

                <h3 className="text-xl font-bold text-black mb-2">{plan.name}</h3>
                <div className="mb-5">
                  <span className="text-3xl font-bold text-purple-700">{plan.price}</span>
                  <span className="block text-sm text-gray-500 mt-1">{m.perServer}</span>
                </div>

                <ul className="space-y-3 mb-6 flex-1">
                  {plan.features.map((feature) => (
                    <li key={feature} className="flex items-start text-gray-700">
                      <Check className="w-5 h-5 text-purple-600 mr-2 flex-shrink-0 mt-0.5" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <p className="text-sm text-gray-500 mb-5">
                  {m.extraHour}{' '}
                  <span className="font-semibold text-gray-800">{plan.extraHour}</span>
                </p>

                <a
                  href="#contact"
                  className={`block text-center font-bold py-3 px-4 rounded-lg transition duration-300 ${
                    featured
                      ? 'bg-purple-600 text-white hover:bg-purple-700'
                      : 'bg-purple-50 text-purple-800 hover:bg-purple-100'
                  }`}
                >
                  {m.cta}
                </a>
              </div>
            );
          })}
        </div>

        <p className="text-center text-sm text-gray-500 mt-8 max-w-3xl mx-auto">{m.footnote}</p>
      </div>
    </section>
  );
};

export default MonitoringPlans;
